import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Platform} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {NavService} from './services/nav.service';
import {AppVersion} from '@ionic-native/app-version/ngx';
import {AuthService} from './services/auth.service';
import {environment} from '../environments/environment';
import {MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService} from '@azure/msal-angular';
import {filter, takeUntil} from 'rxjs/operators';
import {InteractionStatus} from '@azure/msal-browser';
import {Subject, Subscription} from 'rxjs';
import {EventsService} from './services/events.service';
import {UserInfoModel} from './services/models/user-info.model';
import {UserService} from './services/user.service';
import { register } from 'swiper/element/bundle';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    private readonly _destroying$ = new Subject<void>();

    constructor(
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        private nav: NavService,
        private event: EventsService,
        private appVersion: AppVersion,
        private authService: AuthService,
        public userService: UserService,
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private msalService: MsalService,
        private msalBroadcastService: MsalBroadcastService,
    ) {
        if (environment.production) {
            console.info(`🚨 Console output is disabled on production!`);
            console.log = function (): void { };
            console.debug = function (): void { };
            console.warn = function (): void { };
            console.info = function (): void { };
        }

        this.initializeApp();
    }

    ngOnInit(): void {
        if (environment.platform === 'website') {
            this.msalBroadcastService.inProgress$
                .pipe(
                    // Filtering for all interactions to be completed
                    filter((status: InteractionStatus) => status === InteractionStatus.None),
                    takeUntil(this._destroying$)
                )
                .subscribe(() => {
                    this.checkAndSetActiveAccount();
                })
        }
        register();
    }

    initializeApp() {
        this.platform.ready().then(() => {
            console.log('this.platform.ready() - OK')

            if ((this.platform.width() < 854 && this.platform.height() < 854) && this.platform.is('mobile')) {
                this.authService.appMobile = true;
            }

            this.statusBar.styleDefault();
            this.splashScreen.hide();

            this.platform.backButton.subscribe(() => {
                this.nav.back();
            });

            if (this.platform.is('cordova')) {
                this.appVersion.getVersionCode()
                    .then((appVersionCode) => {
                        this.authService.appVersionCode = appVersionCode;
                        if (this.platform.is('ios')) {
                            this.authService.appVersion = appVersionCode;
                            this.authService.appPlatform = 'ios';
                        }
                        console.log(appVersionCode);
                    });
                this.appVersion.getVersionNumber()
                    .then((appVersionNumber) => {
                        this.authService.appVersionNumber = appVersionNumber;
                        if (this.platform.is('android')) {
                            this.authService.appVersion = appVersionNumber;
                            this.authService.appPlatform = 'android';
                        }
                        console.log(appVersionNumber);
                    });
            } else {
                this.authService.appVersionNumber = environment.appVersionNumber;
                this.authService.appVersionCode = environment.appVersionNumber;
                this.authService.appVersion = environment.appVersionNumber;
            }
            console.log('appVersionNumber', this.authService.appVersionNumber);
            console.log('appVersionCode', this.authService.appVersionCode);
            console.log('appVersion', this.authService.appVersion);
            console.log('appPlatform', this.authService.appPlatform);
            console.log('appMobile', this.authService.appMobile);
        }).catch((e) => {console.log('this.platform.ready() - ERROR', e)});
    }

    checkAndSetActiveAccount(){
        /**
         * If no active account set but there are accounts signed in, sets first account to active account
         * To use active account set here, subscribe to inProgress$ first in your component
         * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
         */
        console.log('AppComponent.checkAndSetActiveAccount')
        let activeAccount = this.msalService.instance.getActiveAccount();

        if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
            let accounts = this.msalService.instance.getAllAccounts();
            this.msalService.instance.setActiveAccount(accounts[0]);
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
        this._destroying$.next(null);
        this._destroying$.complete();
    }
}
